import { cached, tracked } from '@glimmer/tracking';
import type {
  LocationType,
  PropertyRowDataItem,
} from 'uplisting-frontend/services/calendar/-internals/types';
import { OccasionDto } from 'uplisting-frontend/services/calendar/-internals/dto';
import { OccasionMeta } from 'uplisting-frontend/services/calendar/-internals/meta';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import BookingModel from 'uplisting-frontend/models/booking';
import BookingRequestModel from 'uplisting-frontend/models/booking-request';

interface IOccasionRecord {
  model: PropertyRowDataItem;
  dto: OccasionDto;
  meta: OccasionMeta;
}

export class OccasionRecord implements IOccasionRecord {
  @tracked dto!: OccasionDto;
  @tracked meta!: OccasionMeta;
  @tracked model!: PropertyRowDataItem;

  constructor(context, model: PropertyRowDataItem) {
    this.model = model;

    this.dto = new OccasionDto(context, model);
    this.meta = new OccasionMeta(context, model);
  }

  @cached
  get price(): ModelRegistry['price'] | undefined {
    if (
      this.model instanceof BookingModel ||
      this.model instanceof BookingRequestModel
    ) {
      if (!this.model.belongsTo('price').value()) {
        return;
      }

      return this.model.price;
    }
  }

  @cached
  get location(): LocationType {
    return this.model.multiUnit || this.model.property;
  }

  @cached
  get changeover(): ModelRegistry['changeover'] | undefined {
    if (!(this.model instanceof BookingModel)) {
      return;
    }

    return (
      (this.model.belongsTo('changeover').value() as
        | ModelRegistry['changeover']
        | null) ?? undefined
    );
  }
}
